import React from 'react';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import * as BuilderUI from '../../../../BuilderUI';
import useMeasureFilterFormContext from '../utils/useMeasureFilterFormContext';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';
import { theme } from '../../../../../../styles/theme';
import {
  SingleSelect,
  SingleSelectOption,
} from '../../../../../Dropdown/SingleSelect';

interface IProps {
  options: IMeasureFilterValue[];
  onAdd: (measureKey: string) => void;
}

const Label = styled(BuilderUI.LabelAction)`
  &:hover,
  [aria-expanded='true'] & {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

const AddMeasureFilterMenu = ({ options, onAdd }: IProps) => {
  const { control } = useMeasureFilterFormContext();

  const filters = useWatch({
    name: 'filters',
    control,
  });

  return (
    <SingleSelect trigger={<Label>+ Filter</Label>} placement="bottom-start">
      {options
        // We allow only one filter per measure - therefore filtering options
        .filter(
          (option) =>
            !filters.find((filter) => filter?.measureKey === option.measureKey),
        )
        .map(({ measureKey }) => (
          <SingleSelectOption
            key={measureKey}
            label={measureKey}
            onClick={() => onAdd(measureKey)}
          />
        ))}
    </SingleSelect>
  );
};

export default AddMeasureFilterMenu;
